import type { UserModel } from "~/models/User.model";
import { useAuthStore } from "~/stores/auth";
export default defineNuxtRouteMiddleware(async (to, from) => {
  useAuthStore().setAuthenticationRequired(true);
  const $localePath = useLocalePath();
  const authStore = useAuthStore();
  let user: UserModel;

  if (authStore.user.id) {
    user = authStore.user;
  } else {
    user = await authStore.getUser();
  }
  const locale = useNuxtApp().$i18n.locale.value;
  const missingStepRouteName = useAuthStore()
    .missingStep?.replace(/^\/?/, "")
    .replace(new RegExp(`^${locale}/?`), "")
    .replace(/\//g, "-");
  console.log("missingStepRouteName", missingStepRouteName, to.name?.toString().startsWith(missingStepRouteName));
  if (missingStepRouteName && useAuthStore().missingStep && !to.name?.toString().startsWith(missingStepRouteName)) {
    location.pathname = useAuthStore().missingStep;
  } else if (!missingStepRouteName && !to.name?.toString().startsWith("account")) {
    return navigateTo({
      path: $localePath("/account/dashboard"),
      query: from.query,
    });
  }
  if (!user?.id) {
    return navigateTo({
      path: $localePath("/login"),
      query: from.query,
    });
  }
});
